import VideoPlayer from './VideoPlayer'
export { VideoPlayer }
export default VideoPlayer
